import { configureStore } from '@reduxjs/toolkit'
import { history } from '../router/navigation'

import userReducer, { userSlice } from '../redux/features/user/userSlice'
import pagesReducer, { pagesSlice } from '../redux/features/pages/pagesSlice'
import stikisReducer from '../redux/features/stikis/stikisSlice'
import sharesReducer from '../redux/features/shares/sharesSlice'
import uiReducer from '../redux/features/ui/uiSlice'

export default configureStore({
  reducer: {
    user: userReducer,
    pages: pagesReducer,
    stikis: stikisReducer,
    shares: sharesReducer,
    ui: uiReducer,
  },
})
